"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgInviteStruct = exports.INVITE_DECLINED = exports.INVITE_ACCEPTED = exports.INVITE_PENDING = void 0;
const superstruct_1 = require("superstruct");
const orgMember_1 = require("./orgMember");
const utils_1 = require("../utils");
exports.INVITE_PENDING = 'pending';
exports.INVITE_ACCEPTED = 'accepted';
exports.INVITE_DECLINED = 'declined';
exports.OrgInviteStruct = (0, superstruct_1.object)({
    id: (0, superstruct_1.string)(),
    email: (0, superstruct_1.string)(),
    organisationId: (0, superstruct_1.string)(),
    organisationName: (0, superstruct_1.string)(),
    role: (0, superstruct_1.enums)([orgMember_1.ROLE_ADMIN, orgMember_1.ROLE_COUNTER]),
    inviteStatus: (0, superstruct_1.enums)([exports.INVITE_PENDING, exports.INVITE_ACCEPTED, exports.INVITE_DECLINED]),
    createdAt: (0, superstruct_1.optional)(utils_1.TimestampStruct),
    acceptedAt: (0, superstruct_1.optional)(utils_1.TimestampStruct),
});
exports.OrgInviteStruct.type = 'OrgInvite';
//# sourceMappingURL=orgInvite.js.map